import { render, staticRenderFns } from "./ManufacturingScreen.vue?vue&type=template&id=3e6cf4c0&scoped=true&"
import script from "./ManufacturingScreen.vue?vue&type=script&lang=js&"
export * from "./ManufacturingScreen.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturingScreen.vue?vue&type=style&index=0&id=3e6cf4c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6cf4c0",
  null
  
)

export default component.exports